// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type CreditCard24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const CreditCard24: FC<CreditCard24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="25"
        >
            <path d="M22 6.485v12c0 .55-.196 1.02-.587 1.413a1.926 1.926 0 0 1-1.413.587H4c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 18.485v-12c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 4 4.485h16c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412Zm-18 2h16v-2H4v2Zm0 4v6h16v-6H4Z" />
        </svg>
    );
};

export default CreditCard24;
